import React from 'react';
import { useSelector } from 'react-redux';
import { DomHelpers, StringHelpers } from 'e4shared';
import Bullet from 'components/prism/bullet';
import Toggle from 'components/prism/toggle';

export const Metrics = ({ text, period, setPeriod, data, loading }) => {
    const loaded = React.useRef(null);
    const user = useSelector(state => state.user.user);

    const [explainer, setExplainer] = React.useState('');

    const resizeHandler = () => {
        const containers = document.getElementsByClassName('prism-metric-score-value');
        [...containers].map(x => DomHelpers.shrinkFont('label-text-fit', 32, x));
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            resizeHandler();
        }
    }, [loaded?.current, loading]);

    React.useEffect(() => {
        switch (period) {
            case 'W':
                setExplainer(text.infoWeek);
                break;
            case 'M':
                setExplainer(text.infoMonth);
                break;
            case 'Q':
                setExplainer(text.infoQuarter);
                break;
        }
    }, [period]);

    return (
        <div ref={loaded}>
            <div className="two-col flex flex-center mb10">
                <h2 className="flex-grow mr20">{text.title}</h2>
                <div className="text-right">
                    <Toggle value={period} onChange={setPeriod}>
                        <button value="W">{text.week}</button>
                        <button value="M">{text.month}</button>
                        <button value="Q">{text.quarter}</button>
                    </Toggle>
                </div>
            </div>
            <div className={data.length > 1 ? 'two-col' : ''}>
                {data.map(item => {
                    const infinite = item.change === -2147483648;

                    return (
                        <div data-testid="metric-item" key={`metric-${item.id}`} className="prism-metric">
                            <div className="prism-metric-name">{item.name}</div>
                            {loading ? (
                                <i className="fa fa-spinner fa-spin" />
                            ) : (
                                <div className="prism-metric-score">
                                    <div className="prism-metric-score-value" style={{ overflow: 'hidden' }}>
                                        <span className="label-text-fit">
                                            {StringHelpers.formatMetric(item.format, item.value, user.currencySymbol)}
                                        </span>
                                    </div>
                                    <Bullet
                                        icon={infinite || item.change >= 0 ? 'arrow-up' : 'arrow-down'}
                                        value={infinite ? '∞' : `${item.change >= 0 ? item.change : item.change * -1}%`}
                                        style={infinite || item.change >= 0 ? 'positive' : 'negative'}
                                    />
                                </div>
                            )}
                            <div className="mt10">{explainer}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Metrics;
